export default __webpack_public_path__ + "static/media/288.63ad8f8e.png";